var booleanOptions = [true,false];

export const propertyOptions = [
  {
    key:"Unit",
    value:"unit",
    isBoolean:false,
    valueType:"input"
  },
  {
    key:"Location",
    value:"propertyLocation",
    isBoolean:false,
    selectFilter:true,
    selectOptions:["Lahaina Shores","Puamana"],
    valueType:"select"
  },
  {
    key:"Property Address",
    description:"propertyAddress",
    isBoolean:false,
    valueType:"textarea"
  },
  {
    key:"Property Type",
    value:"propertyType",
    isBoolean:false,
    selectFilter:true,
    selectOptions:["Oceanfront","Ocean View","Garden View","Mountain View"],
    description:"propertyTypeDescription",
    valueType:"select"
  },
  {
    key:"Misc. Notes",
    isBoolean:false,
    description:"miscDescription"
  },
  {
    key:"Square Feet",
    value:"squareFeet",
    isBoolean:false,
    valueType:"input"
  },
  {
    key:"Sleeps",
    value:"guest",
    isBoolean:false,
    selectFilter:true,
    selectOptions:["1","2","3","4","5","6","7","8"],
    valueType:"select"
  },
  {
    key:"Stories",
    value:"stories",
    isBoolean:false,
    selectFilter:true,
    selectOptions:["1","2","3","1 + Loft"],
    description:"storiesDescription",
    valueType:"select"
  },
  {
    key:"Bedroooms",
    value:"bedrooms",
    isBoolean:false,
    selectFilter:true,
    selectOptions:["0","1","2","3","4"],
    description:"bedroomsDescription",
    valueType:"select"
  },
  {
    key:"Bathrooms",
    value:"bathrooms",
    isBoolean:false,
    selectFilter:true,
    selectOptions:["1","1.5","2","2.5","3","3.5","4"],
    description:"bathroomsDescription",
    valueType:"select"
  },
  {
    key:"Kitchen",
    isBoolean:false,
    description:"kitchenDescription",
  },
  {
    key:"Family Room",
    isBoolean:false,
    description:"familyRoomDescription",
  },
  {
    key:"Lanai",
    isBoolean:false,
    description:"lanaiDescription"
  },
  {
    key:"Air Conditioning",
    value:"airConditioning",
    isBoolean:true,
    selectFilter:true,
    selectOptions:booleanOptions,
    keywords:['air','conditioning', 'ac', 'air conditioning'],
    description:"airConditioningDescription",
    valueType:"select"
  },
  {
    key:"Washer / Dryer",
    value:"washerDryer",
    isBoolean:true,
    selectFilter:true,
    selectOptions:booleanOptions,
    keywords:['washer','dryer', 'washer dryer'],
    description:"washerDryerDescription",
    valueType:"select"
  },
  {
    key:"Sofa Bed",
    value:"sofaBed",
    isBoolean:true,
    selectFilter:true,
    selectOptions:booleanOptions,
    keywords:['sofa','sofa bed','pullout','bed'],
    description:"sofaBedDescription",
    valueType:"select"
  },
  {
    key:"Coffee Maker",
    value:"coffeeMaker",
    isBoolean:true,
    selectOptions:booleanOptions,
    keywords:['coffee'],
    description:"coffeeMakerDescription",
    valueType:"select"
  },
  {
    key:"BBQ",
    value:"bbqType",
    isBoolean:false,
    selectOptions: ["Charcoal","Gas","Charcoal & Gas","Community Gas BBQ"],
    description:"bbqTypeDescription",
    valueType:"select"
  },
  {
    key:"Flooring",
    isBoolean:false,
    description:"flooringDescription",
    valueType:"textarea"
  },
  {
    key:"Parking",
    value:"parking",
    isBoolean:false,
    selectOptions: ["0","1","2"],
    description:"parkingDescription",
    valueType:"select"
  },
  {
    key:"Wifi Information",
    description:"wifiInformation",
    isBoolean:false,
    valueType:"textarea"
  },
  {
    key:"Lock Code",
    description:"lockCode",
    isBoolean:false,
    valueType:"textarea"
  }
];



// WEBPACK FOOTER //
// ./src/propertyConfig.js